/**
 * contract-text.tsx — hiển thị nội dung điều khoản đúng chuẩn văn bản hợp đồng (đoạn đánh số treo, gạch đầu dòng,
 * tiêu đề bên, BẢNG kẻ) từ chữ thuần. Dùng ở trang ký của khách và chi tiết hợp đồng. Không dựng HTML từ đầu vào:
 * mọi chữ đi qua React (tự escape).
 */
import { parseBlocks, type Block } from './contract-blocks'

function BlockView({ b }: { b: Block }) {
  switch (b.type) {
    case 'bullet':
      return <div className="flex gap-2 pl-4"><span aria-hidden>•</span><span className="min-w-0 flex-1">{b.text}</span></div>
    case 'num':
      return <div className="flex gap-2"><span className="w-10 shrink-0 font-semibold">{b.num}</span><span className="min-w-0 flex-1">{b.text}</span></div>
    case 'party':
      return <p className="pt-2 font-semibold">{b.text}</p>
    case 'table':
      return (
        <div className="overflow-x-auto py-1">
          <table className="w-full border-collapse text-xs">
            <thead>
              <tr>{b.header.map((h, i) => <th key={i} className="border border-border bg-muted px-2 py-1 text-center font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody>
              {b.rows.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} className="border border-border px-2 py-1 align-top">{c}</td>)}</tr>)}
            </tbody>
          </table>
        </div>
      )
    default:
      return <p>{b.text}</p>
  }
}

export function ContractText({ text }: { text: string }) {
  return <div className="space-y-1">{parseBlocks(text).map((b, i) => <BlockView key={i} b={b} />)}</div>
}
